import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { LoadingSpinner } from '@mobi/component-library/Feedback/LoadingSpinner'
import { MainContainerStyled } from '@core/Components/Containers/MainContainer.styles'
import { logError } from '@core/Utils'
import styled from '@emotion/styled'
import { trackShortenedUrlAccess } from './analytics'
import { AppRoutes } from '@core/AppRoutes'
import { resolveLongUrl } from './api'

export const ShortenedUrlHandler: React.FC = () => {
  const navigate = useNavigate()
  const { urlKey } = useParams<{ urlKey?: string }>()

  useEffect(() => {
    const fetchFullUrl = async () => {
      try {
        if (!urlKey) throw new Error('No URL key provided')

        const redirectURL = await resolveLongUrl(urlKey)

        trackShortenedUrlAccess(redirectURL)

        navigate(redirectURL.pathname + redirectURL.search, {
          replace: true,
        })
      } catch (e) {
        logError(`Failed to navigtate from shortened link - ${(e as Error).message}`, true)

        // Default to Home page
        navigate(AppRoutes.Home, {
          replace: true,
        })
      }
    }

    fetchFullUrl()
  }, [urlKey, navigate])

  return (
    <MainContainerStyled>
      <SpinnerContainerStyled>
        <LoadingSpinner />
      </SpinnerContainerStyled>
    </MainContainerStyled>
  )
}

const SpinnerContainerStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '90vh',
})
